const googleServices = {
  infoWindowConstructor: null,
  markerConstructor: null,
  placesService: null,
};

export default googleServices;
